import {_} from 'lodash';
import {IMessage, IRouteDefinitionParams, ITableColumn} from '../../../../index';
import {template as tpl, viewModel as SearchMessageTemplateViewModel} from "../../../messages/search";
import {IDialogOptions} from "../../../dialog/index";
import {ISplitButtonParams} from "@component/button/splitButton/split-button";

export let template = tpl;

interface IParams {
    dialog: IDialogOptions
    callback: (messageTemplate: IMessage) => void
}

export class viewModel extends SearchMessageTemplateViewModel {
    public override TABLE: ITableColumn[] = [
        {
            key: "Id",
            label: "Id"
        },
        {
            key: "Name",
            label: "Navn"
        },
        {
            key: "subject",
            label: "Emne"
        },
        {
            key: "recipientfield",
            label: "Mottaksfelt"
        },
        {
            key: "addrecipient",
            label: "Mottakere / kopi til",
            count: true,
        },
        {
            key: "messagetypename",
            label: "Type",
            center: true,
        },
        {
            key: 'messagelog',
            label: 'Logg',
            count: true,
        },
        {
            key: 'active',
            label: 'Aktiv',
            center: true,
        },
    ];

    constructor(private params: IParams & IRouteDefinitionParams) {
        super(_.defaultsDeep(params, {
            __routeDef: {
                serviceName: 'searchmessage',
                showHeading: false,
            }
        }))
    }

    protected override populatePageButtons() {
    };

    /** Pick dialog is for choosing a message flow — no create action. */
    protected override getSearchSplitButtonParams(): ISplitButtonParams | null {
        return null
    }

    protected override getSearchHeaderSplitButtonParams(): ISplitButtonParams | null {
        return null
    }

    protected override onRowClick(data: IMessage) {
        this.params.callback(data);
        this.params.dialog.doClose?.();
    }

    protected override onRowKeyUp(data: IMessage, event: KeyboardEvent) {
        if (event.key == 'Enter') {
            this.onRowClick(data);
        }
    };

}